import { render } from "./UBN.vue?vue&type=template&id=e40cdb7c"
import script from "./UBN.vue?vue&type=script&lang=js"
export * from "./UBN.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__